var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedailleBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    "data-name": "Flat Color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m18.57,0.9a1,1 0 0 0 -0.82,-0.43l-5.14,0a1,1 0 0 0 -0.94,0.65l-0.92,2.44l-0.92,-2.44a1,1 0 0 0 -0.94,-0.65l-5.14,0a1,1 0 0 0 -0.82,0.43a1,1 0 0 0 -0.12,0.91l2.17,5.95a1,1 0 0 0 0.71,0.63l0.23,0a1,1 0 0 0 0.69,-0.27a6,6 0 0 1 3.85,-1.65a1.08,1.08 0 0 0 0.29,-0.07a1.08,1.08 0 0 0 0.29,0.09a6,6 0 0 1 3.85,1.65a1,1 0 0 0 0.69,0.27l0.23,0a1,1 0 0 0 0.71,-0.63l2.17,-5.95a1,1 0 0 0 -0.12,-0.93z",
    fill: "#b56138",
    id: "secondary"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.78,
    cy: 12.47,
    fill: "#fc9d65",
    id: "primary",
    r: 8,
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#b56138",
    fontFamily: "Helvetica",
    fontSize: 17,
    fontWeight: "bold",
    id: "svg_1",
    stroke: "#000000",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(1 0 0 1 0 0) matrix(0.921522 0 0 0.921522 0.43873 -0.999051)",
    x: 11.47,
    xmlSpace: "preserve",
    y: 20.49
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedailleBronze);
export default __webpack_public_path__ + "static/media/medaille_bronze.e9be94661343876a21a07ed7db6a2f47.svg";
export { ForwardRef as ReactComponent };